import {
  postData,
  getData,
  deleteData
} from './request'

// 创建星标
export function star(paload, cb) {
  postData(`/api/v3/tags`, paload, {}, cb)
}
// 删除星标
export function unstar(paload, cb) {
  deleteData(`/api/v3/tags/files`, paload, {}, cb)
}
// 获取星标列表
export function getStars({count,offset},cb) {
  return getData(`/api/v3/tags?count=${count}&offset=${offset}`, {}, cb)
}


// WEBPACK FOOTER //
// ./src/store/service/starred.js